import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import HorarioDiaService from "service/meta/producao/HorarioDiaService";
import { TextMatchModeOptions, filterApplyTemplate } from "utils/filterUtils";

const horarioDiaService = new HorarioDiaService();

export default function HorarioDiaListagem() {

    const [queryParameters] = useSearchParams();

    const [titulo, setTitulo] = useState<string>('Horários');

    const defaultFilters: DataTableFilterMeta = {
        nome: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
    }

    return (

        <BaseListagem ordenacao="nome,ASC" service={horarioDiaService} urlService="/horarioDia" tituloPagina={titulo} defaultFilters={defaultFilters} showClearFilterButton nome="horarioDia" >
            <Column field="nome" header="Nome" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
        </BaseListagem>
    )
}